/* eslint-disable no-inner-declarations */

export default function singleMap() {

  if( $('#single-project-map').length ){
      const google = window.google;

      var latitude = $('#single-project-map').attr('data-latitude');
      var longitude = $('#single-project-map').attr('data-longitude');
    
      var point = new google.maps.LatLng(latitude, longitude);
    
      function initMap() {
    
        var mapOptions = {
          mapTypeControl: false,
          streetViewControl: false,
          scrollwheel: false,
          zoom: 13,
          center: point,
          styles: [{'stylers':[{'hue':'#2c3e50'},{'saturation':250}]},{'featureType':'road','elementType':'geometry','stylers':[{'lightness':50},{'visibility':'simplified'}]},{'featureType':'road','elementType':'labels','stylers':[{'visibility':'off'}]}],
        };
    
        var mapElement = document.getElementById('single-project-map');
        var map = new google.maps.Map(mapElement, mapOptions);
    
        var marker = new google.maps.Marker({
          position: point,
          icon: 'https://stroumbeweegt.lu/wp-content/uploads/2020/08/map-marker-select.svg',
        });
    
        marker.setMap(map);
      }
    
      initMap();
    }

}



// WEBPACK FOOTER //
// ./scripts/modules/singleMap.js